<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import { fly } from 'svelte/transition'

    import moment from 'moment'

    import Modal from '../../components/Modal/Modal.svelte'
    import ModalOverlay from '../../components/Modal/ModalOverlay.svelte'
    // import SveltePerfectScrollbar from '../../components/SveltePerfectScrollbar/SveltePerfectScrollbar.svelte'
    // import ListClients from '../Programs/ListClients.svelte'
    // import ListField from '../Programs/ListField.svelte'
    import SmartField from '../../components/SmartField/SmartField.svelte'
    import SmartSelect from '../../components/SmartField/SmartSelect.svelte'
    import ThinButton from '../../components/ThinButton/ThinButton.svelte'
    import userStore from '../../stores/user'
    

    export let data
    export let create = false
    export let admin = false

    
    let ctrlsDisabled = false,
        roles = [
            { value: 0, text: 'Administrator' }, 
            { value: 1, text: 'Manager (Livello 1)' },
            { value: 2, text: 'Manager (Livello 2)' },
            { value: 3, text: 'Manager (Livello 3)' },
            { value: 4, text: 'Manager (Livello 4)' },
            { value: 5, text: 'Operatore' },
        ],
        validFields = {
            name: true,
            username: true,
            password: true
        },
        model = {
            name: '',
            username: '',
            password: '',
            category: $userStore.sector.id,
            telegram: '',
            email: '',
            role: 5
        },
        credentialsBusy = false,
        credentialsDisabled = false



    const dispatch = createEventDispatcher ();

    const save = (event) => {
        if (validateModel ()) {
            const new_data = { ...model }
            if (new_data.password.trim() === '')
                delete new_data.password;

            ctrlsDisabled = true;
            dispatch ('save', {
                data: new_data,
                previous: data,
                create
            })
        }
    }

    const cancel = (event) => {
        ctrlsDisabled = true;
        dispatch ('cancel', {
            data
        })
    }

    const sendCredentials = event => {
        new Promise ((resolve, reject) => {
            credentialsBusy = true
            credentialsDisabled = true
            dispatch ('credentials', {
                data,
                resolve,
                reject
            })
        }).then (() => {
            credentialsBusy = false
        }).catch (error => {
            credentialsBusy = false
        })
    }

    const validateModel = () => {
        validFields.name = model.name !== ''
        validFields.username = model.username !== ''
        if (admin)
            validFields.password = model.password === '' || model.password.length > 5

        // console.log ('valid', Object.keys(validFields).map(it => validFields[it]).every(it => it === true))

        return Object.keys(validFields).map(it => validFields[it]).every(it => it === true)
    }

    const onRoleChange = event => {
        // console.log ('onRoleChange', event.detail)
        model.role = event.detail
    }

    const loadData = () => {
        const {
            last_seen,
            ip_address,
            image,
            disabled,
            ...subset
        } = data;

        model = {
            ...model, 
            ...subset
        }
    }
    
    $: {
        if (data)
            loadData (data)
    }
</script>

<ModalOverlay />
{#if data || create}
    <Modal classes="AlertEditor" hideOverlay>
        <div class="Editor basic-panel-content">
            <div class="content">
                <div class="heading">{create ? 'Crea Utente' : data.name}</div>
                <!-- <SveltePerfectScrollbar height={350}> -->
                    <div class="form">
                        <SmartField name="name" label="Nome Completo" invalid={validFields.name === false} bind:value={model.name} />
                        <SmartField name="username" label="Username" invalid={validFields.username === false} bind:value={model.username} />
                        {#if admin}
                            <SmartField name="password" label="Password" invalid={validFields.password === false} bind:value={model.password} type="password" />
                            <SmartSelect name="role" value={model.role} options={roles} on:fieldchange={onRoleChange} />
                        {/if}
                        <SmartField name="email" label="Email Address" bind:value={model.email} />
                        
                        {#if !create}
                            <ThinButton label="Invia credenziali" busy={credentialsBusy} on:click={sendCredentials} disabled={credentialsDisabled} />
                        {/if}
                    </div>
                <!-- </SveltePerfectScrollbar> -->
            </div>
        </div>
        <div class="ctrls" in:fly={{ y: -60, duration: 300, delay: 300 }}>
            <button class="btn btn-sm btn-primary" disabled={ctrlsDisabled} on:click={save}>Salva Modifiche</button>
            <button class="btn btn-sm btn-danger" disabled={ctrlsDisabled} on:click={cancel}>Annulla</button>
        </div>
    </Modal>
{/if}


<style>
    :global(.AlertEditor) .basic-panel-content {
        width: 600px;
        /* height: 400px; */
        padding: 0;
        /* text-align: center; */
        position: relative;
        z-index: 2;
        
    }
    .Editor .content {
        position: relative;
        /* width: calc(100% - 260px); */
        height: 100%;
        overflow: auto;
        /* padding: 20px; */
    }
    .Editor .heading {
        font-size: 20px;
        color: #465d6f;
        padding: 10px 20px;
        text-transform: capitalize;
    }
    .Editor .form {
        padding: 20px;
    }
    .ctrls {
        margin-top: 10px;
        text-align: left;
        position: relative;
        z-index: 1;
    }
    .ctrls :global(button) {
        padding: .40rem 1.3rem;
    }
    .ctrls :global(.btn) {
        margin-right: 5px;
    }

    @media(max-width: 800px) {
        :global(.AlertEditor) {
            width: 100%;
            height: 100%;
        }
        :global(.AlertEditor) .basic-panel-content {
            width: calc(100% - 50px);
            /* height: 100%; */
            left: 50px;
        }
    }
</style>